import type React from "react";
import { CheckIcon } from "@/components/icon";

export interface HourSectionProps {
	id: string;
	time: string;
	label: string;
	title: string;
	text: string;
	facts: string[];
	flip?: boolean;
	children: React.ReactNode;
}

// One stamped hour of the workday: copy on one side, product visual on the
// other. `flip` swaps the sides on wide screens.
export function HourSection({
	id,
	time,
	label,
	title,
	text,
	facts,
	flip = false,
	children,
}: HourSectionProps) {
	return (
		<section data-slot="band" id={id}>
			<div data-slot="hour" data-flip={flip || undefined}>
				<div data-slot="hour-copy">
					<div data-slot="stamp">
						<time data-slot="stamp-time">{time}</time>
						<span data-slot="eyebrow">{label}</span>
					</div>
					<h2 data-slot="section-title">{title}</h2>
					<p data-slot="hour-text">{text}</p>
					<ul data-slot="facts">
						{facts.map((fact) => (
							<li key={fact} data-slot="fact">
								<CheckIcon />
								<span>{fact}</span>
							</li>
						))}
					</ul>
				</div>
				{children}
			</div>
		</section>
	);
}
